import { render, staticRenderFns } from "./TiposTurnoProfesional.vue?vue&type=template&id=1b0adc28"
import script from "./TiposTurnoProfesional.vue?vue&type=script&lang=js"
export * from "./TiposTurnoProfesional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports